import * as d3 from 'd3'
export default {
  methods: {

    chart_ITRs(selection) {
    
      selection
      .append('rect')
      .attr('x', 765).attr('y', 40).attr('rx', 5)
      .attr('width', 800).attr('height', 153)
      .attr('fill', 'none').attr('stroke', '#bcbcbc').attr('stroke-width', .5)

      this.links.forEach(d=> {
        let link = d3.select(`#${d.id}`).nodes()[0]
        if(link) {
          this.current.svg = d.svg
          d3.select(`#${d.id}`).call(this.call_Navi)
        }
      })

      let cnt = 0
      this.subSystem.forEach((d,i)=> {
        let subSys = d3.select(`#SUBSYS-${d.SUBSYS}`).nodes()[0]
        if(subSys) {
          let x = Number(d3.select(`#SUBSYS-${d.SUBSYS}`).select('rect').attr('x'))
          let y = Number(d3.select(`#SUBSYS-${d.SUBSYS}`).select('rect').attr('y'))

          d3.select(`#SUBSYS-${d.SUBSYS}`).call(this.call_Link, 'SUBSYS', d)

          let chart = selection
          .append('g')
          .attr('transform', `translate(${x}, ${y})`)

          if(d.A_TOT>0) {
            chart
            .append('rect')
            .attr('y', -4).attr('width', 120).attr('height', 2).attr('fill', '#EBEBEB')
            chart
            .append('rect')
            .attr('y', -4).attr('width', (120/100)*d.A_PRO).attr('height', 2).attr('fill', '#83D2F5')
          }
          if(d.B_TOT>0) {
            chart
            .append('rect')
            .attr('y', 42).attr('width', 120).attr('height', 2).attr('fill', '#EBEBEB')
            chart
            .append('rect')
            .attr('y', 42).attr('width', (120/100)*d.B_PRO).attr('height', 2).attr('fill', '#44A9DF')
          }

          if(cnt == 0) this.draw_Detail('SUBSYS', d)
          cnt ++
        }
      })

      
      this.system.forEach((d,i)=> {
        let sys = d3.select(`#SYS-${d.SYS}`).nodes()[0]
        if(sys) {
          let x = Number(d3.select(`#SYS-${d.SYS}`).select('rect').attr('x'))
          let y = Number(d3.select(`#SYS-${d.SYS}`).select('rect').attr('y'))

          d3.select(`#SYS-${d.SYS}`).call(this.call_Link, 'SYS', d)

          let chart = selection
          .append('g')
          .attr('transform', `translate(${x}, ${y})`)

          if(d.A_TOT>0) {
            chart
            .append('rect')
            .attr('y', -4).attr('width', 120).attr('height', 2).attr('fill', '#EBEBEB')
            chart
            .append('rect')
            .attr('y', -4).attr('width', (120/100)*d.A_PRO).attr('height', 2).attr('fill', '#83D2F5')
          }
          if(d.B_TOT>0) {
            chart
            .append('rect')
            .attr('y', 42).attr('width', 120).attr('height', 2).attr('fill', '#EBEBEB')
            chart
            .append('rect')
            .attr('y', 42).attr('width', (120/100)*d.B_PRO).attr('height', 2).attr('fill', '#44A9DF')
          }

          if(cnt == 0) this.draw_Detail('SYS', d)
          cnt ++
        }
      })


    },
  }
}